"use client"

import { useState } from "react"
import { Button } from "@/components/ui/button"
import { AlertTriangle, Home, RefreshCw, Search, User, Mail, ChevronDown, ChevronUp } from "lucide-react"
import Link from "next/link"

export default function Error({
    error,
    reset,
}: {
    error: Error & { digest?: string }
    reset: () => void
}) {
    const [showDetails, setShowDetails] = useState(false)

    return (
        <div className="min-h-screen pt-28 pb-12 flex flex-col items-center font-playfair justify-center p-4">
            <div className="max-w-md w-full bg-white p-8 rounded-lg shadow-lg text-center">
                <AlertTriangle className="h-16 w-16 text-red-500 mx-auto mb-4" />
                <h1 className="text-2xl font-bold mb-4 font-playfair">Algo salió mal</h1>
                <p className="text-gray-600 mb-6">
                    Lo sentimos, ha ocurrido un error inesperado. Por favor, intente nuevamente o navegue a otra sección de la
                    aplicación.
                </p>

                <div className="flex flex-col sm:flex-row gap-4 justify-center mb-6">
                    <Button onClick={reset} className="flex items-center gap-2 bg-primary-gold hover:bg-primary-gold/90">
                        <RefreshCw className="h-4 w-4" />
                        Intentar nuevamente
                    </Button>
                    <Button
                        variant="outline"
                        className="flex items-center gap-2 border-primary-gold text-primary-gold hover:bg-primary-gold/10"
                        asChild
                    >
                        <Link href="/">
                            <Home className="h-4 w-4" />
                            Volver al inicio
                        </Link>
                    </Button>
                </div>

                <div className="grid grid-cols-2 gap-3 mb-6">
                    <Button variant="ghost" size="sm" className="text-gray-600 hover:text-primary-gold" asChild>
                        <Link href="/apartments" className="flex items-center gap-1">
                            <Search className="h-4 w-4" />
                            Apartamentos
                        </Link>
                    </Button>
                    <Button variant="ghost" size="sm" className="text-gray-600 hover:text-primary-gold" asChild>
                        <Link href="/profile" className="flex items-center gap-1">
                            <User className="h-4 w-4" />
                            Mi Perfil
                        </Link>
                    </Button>
                </div>


                {error.digest && (
                    <div className="mt-2 border-t pt-4">
                        <Button
                            variant="ghost"
                            size="sm"
                            onClick={() => setShowDetails(!showDetails)}
                            className="text-gray-500 text-sm mb-2"
                        >
                            {showDetails ? (
                                <>
                                    <ChevronUp className="h-4 w-4 mr-1" />
                                    Ocultar detalles
                                </>
                            ) : (
                                <>
                                    <ChevronDown className="h-4 w-4 mr-1" />
                                    Mostrar detalles
                                </>
                            )}
                        </Button>

                        {showDetails && (
                            <div className="bg-gray-50 p-3 rounded-md text-left mb-4">
                                <p className="text-xs text-gray-500 mb-1">ID del error: {error.digest}</p>
                                <p className="text-xs text-gray-500 mb-1">
                                    Mensaje: {error.message || "No hay mensaje de error disponible"}
                                </p>
                                <p className="text-xs text-gray-500">Nombre: {error.name || "Error"}</p>
                            </div>
                        )}
                    </div>
                )}

            
                <div className="mt-4 text-sm text-gray-500">
                    <p>Si este error persiste, por favor contacte a soporte:</p>
                    <Link
                        href="mailto:palaciosdiegovalentino@gmail.com?subject=Problema con la página Alquileres Temporales&body=Estoy encontrando el siguiente error: "
                        className="flex items-center justify-center gap-1 text-primary-gold hover:underline mt-2"
                    >
                        <Mail className="h-4 w-4" />
                        palaciosdiegovalentino@gmail.com
                    </Link>
                </div>
            </div>
        </div>
    )
}

